/**
 * 入力フォーム用JS
 */

import {
	ClassicEditor,
	AccessibilityHelp,
	Autoformat,
	AutoImage,
	Autosave,
	BlockQuote,
	Bold,
	CloudServices,
	Essentials,
	Heading,
	ImageBlock,
	ImageCaption,
	ImageInline,
	ImageInsert,
	ImageInsertViaUrl,
	ImageResize,
	ImageStyle,
	ImageTextAlternative,
	ImageToolbar,
	ImageUpload,
	Indent,
	IndentBlock,
	Italic,
	Link,
	LinkImage,
	List,
	ListProperties,
	Paragraph,
	SelectAll,
	SimpleUploadAdapter,
	TextTransformation,
	TodoList,
	Underline,
	Undo
} from 'ckeditor5';
import translations from 'ckeditor5/translations/ja.js';
import {} from 'ckeditor5/ckeditor5.css';
import Lightpick from 'lightpick';
import 'lightpick/css/lightpick.css';
import YubinBango from 'yubinbango-core2';
import {} from './jquery.validationEngine-ja';
import {} from './jquery.validationEngine';
import {} from '../../sass/common/validationEngine.jquery.css';
import * as SelectoboxSercher from './selectbox-searcher';

class FormEdit {
    constructor() {
        // 何かフォームフィールドにアクションを起こしたときだけ、
        // ページ離脱時に警告を出す
        this.doAction = false;
        // submit押したときは警告を出さない
        this.isSubmit = false;

        /**************
         *  VARIABLES
         **************/
        if( document.getElementById('max_file_uploads') ){
            this.maxFilenum = document.getElementById('max_file_uploads').value;
        }
        if( document.getElementById('upload_max_filesize') ){
            this.maxFilesize = document.getElementById('upload_max_filesize').value;
        }
        if( document.getElementById('post_max_size') ){
            this.maxPostsize = document.getElementById('post_max_size').value;
        }

        /**************
         *  LISTENER
         **************/
        // 入力済みの色を変える
        this.bgColorEls = document.querySelectorAll('.form-bg');
        this.bgColorEls.forEach(el => {
            this.changeBgColor(el); // 初期設定
            el.addEventListener('keyup', ev => this.changeBgColor(el));
            el.addEventListener('change', ev => this.changeBgColor(el));
            el.addEventListener('blur', ev => this.changeBgColor(el));
        });

        // 自動で次に移動
        this.autoNextInputEls = Array.from(document.getElementsByClassName('auto-next-input'));
        this.autoNextInputEls.forEach(el => this.autoNextInput(el));

        // アップロードされた画像表示
        this.thumbnailEls = Array.from(document.getElementsByClassName('thumbnail'));
        this.thumbnailEls.forEach(el => el.addEventListener('change', ev => this.thumbnail(el, ev)));

        // 画像削除
        this.deleteImgEls = Array.from(document.getElementsByClassName('delete-img'));
        this.deleteImgEls.forEach(el => el.addEventListener('click', ev => this.deleteImg(el, ev)));

        // ドロップエリア
        const dropAreaEls = Array.from(document.getElementsByClassName('drop-area'));
        dropAreaEls.forEach(el => el.addEventListener('dragover', ev => this.dragover(el, ev)));
        dropAreaEls.forEach(el => el.addEventListener('dragleave', ev =>  this.dragleave(el, ev)));
        dropAreaEls.forEach(el => el.addEventListener('drop', ev => this.uploadDocument(el, ev)));

        // 文字数カウント
        this.countWordEls = Array.from(document.getElementsByClassName('count-word'));
        this.countWordEls.forEach(el => el.addEventListener('keyup', ev => this.countWord(el)));

        // 郵便番号から住所を入力
        this.zipEls = Array.from(document.getElementsByClassName('p-postal-code'));
        this.zipEls.forEach(el => el.addEventListener('keyup', ev => this.searchAddressByZip(el, ev)));

        // パスワード表示・非表示トグル
        this.togglePasswordDispEls = Array.from(document.getElementsByClassName('toggle-password-display'));
        this.togglePasswordDispEls.forEach(el => el.addEventListener('click', ev => this.togglePasswordDisplay(el)));

        // datepicker
        this.datepickerEls = Array.from(document.getElementsByClassName('datepicker'));
        this.datepickerEls.forEach(el => this.fireDatepicker(el));

        // WYSIWYGエディター
        this.wysiwygEls = Array.from(document.getElementsByClassName('wysiwyg'));
        this.wysiwygEls.forEach(el => this.fireWysiwyg(el, null));
        // WYSIWYGエディター（多機能）
        this.wysiwyg2Els = Array.from(document.getElementsByClassName('wysiwyg-delux'));
        this.wysiwyg2Els.forEach(el => this.fireWysiwyg(el, 'delux'));

        // ページ離脱を検知したら
        window.addEventListener('beforeunload', ev => this.leaveAlert(ev));
        window.addEventListener('unload', ev => this.leavePage(ev));

        // フォームsubmitクリック
        this.submitBtnEls = Array.from(document.getElementsByClassName('submit-btn'));
        this.submitBtnEls.forEach(el => el.addEventListener('click', () => this.isSubmit = true));

        // フォーム戻るボタンクリック
        this.backBtnEls = Array.from(document.getElementsByClassName('back-btn'));
        this.backBtnEls.forEach(el => el.addEventListener('click', () => this.isSubmit = true));

        // フォームフィールドへのアクション検知
        this.detectAction();

        // ページ初期化
        this.init();
    }

    /**
     * ページ初期化時に実行
     */
    init(){
        // PHPバリデーションのエラー表示があったらエラー箇所へスクロール
        let firstErr;
        let errMsg = document.querySelectorAll('.errMsg');
        for( let el of errMsg ){
            if( el.textContent != '' ){
                firstErr = el;
                break;
            }
        };
        if( firstErr ){
            firstErr.scrollIntoView({block: 'center'});
        }

        // JSバリデーション
        $('.validate-form').validationEngine(
            'attach', {
                scrollOffset: 100,
                promptPosition: 'topLeft:-7,5'//エラーメッセージ位置の指定
            }
        );

        // 残り項目数表示
        const itemsEl = document.querySelector('.remaining .items');
        const numberEl = document.querySelector('.remaining .number');
        if( itemsEl && numberEl ){
            const requireEls = document.querySelectorAll('form .require');
            itemsEl.textContent = requireEls.length;
            numberEl.textContent = requireEls.length;

            const calc = () => {
                let i = 0;
                loop1 : for( let el of requireEls ){
                    // ターゲットの値が○○の場合は必須、のパターン
                    // ターゲットの値が○○の場合は必須のまま
                    //  ターゲットの値が○○でなかったら必須でないので減らしてループ抜ける
                    if( el.classList.contains('require-if') ){
                        const targetEls = document.querySelectorAll(el.dataset.requireField);
                        const targetValue = el.dataset.requireValue;
                        for( let targetEl of targetEls ){
                            if( targetEl.value != targetValue ){
                                i++;
                                continue loop1;
                            }
                        }
                    }
                    
                    if( el.tagName == 'INPUT' || el.tagName == 'SELECT' || el.tagName == 'TEXTAREA' ){
                        if( ((el.type == 'checkbox' || el.type == 'radio') && el.checked)
                         || ((el.type != 'checkbox' && el.type != 'radio') && el.value != '') )
                        {
                            i++;
                        }
                        
                    }else{
                        const inputEls = el.querySelectorAll('input');
                        for( let inputEl of inputEls ){
                            if( inputEl.checked ){
                                i++;
                                break;
                            }
                        };
                    }
                }
                numberEl.textContent = requireEls.length - i;
            }

            requireEls.forEach(el => el.addEventListener('change', ev => calc()));
            const requireIfEls = document.querySelectorAll('.require-if').forEach(el => {
                const targetEls = document.querySelectorAll(el.dataset.requireField);
                targetEls.forEach(targetEl => targetEl.addEventListener('change', ev => calc()));
            });
            calc(); // 初期設定
        }

        //入力済みの色を変える
        if( document.querySelector('form-bg') ){
            $('.form-bg').on('keydown keyup keypress change focus blur', function() {
                if($(this).val() == ''){
                $(this).css({backgroundColor: 'rgb(245, 245, 245)'});
                } else {
                $(this).css({backgroundColor: 'rgb(232, 240, 254)'});
                }
            }).change();
        }

        // 文字数カウント
        this.countWordEls.forEach(el => {
            // wysiwygエディタだったらwysiwygが読み込まれるまで待ってからカウント
            if( el.classList.contains('wysiwyg') ){
                setTimeout(() => {
                    const wysiwygEl = el.nextElementSibling.querySelector('.ck-content');
                    const observer = new MutationObserver(mutation => {
                        this.countWord(mutation[0].target);
                    });
                    observer.observe(wysiwygEl, {subtree: true, childList: true, characterData: true});
                    this.countWord(wysiwygEl);
                    }, 2000);
            }
            // 通常のテキストエリアだったら
            else{
                this.countWord(el)
            }
        });
    }

    /**
     * 入力済みの色を変える
     */
    changeBgColor(el){
        if( el.value == '' ){
            el.style.backgroundColor = 'rgb(245, 245, 245)';
        }else{
            el.style.backgroundColor = 'rgb(232, 240, 254)';
        }
    }

    /**
     * 次の入力に自動focus
     */
    autoNextInput(el){
        const maxlength = el.getAttribute('maxlength');
        if( !maxlength ) return false;

        el.addEventListener('keyup', () => {
            if( el.value.length >= maxlength ){
                document.getElementById(el.dataset.nextTarget).focus();
            }
        });
    }

    /**
     * サムネイル表示
     */
    async thumbnail(el, event) {
        let uploadFile;

        if( event.target.files && event.target.files[0] ){
            uploadFile = event.target.files[0];
        }else if( event.dataTransfer.files && event.dataTransfer.files[0] ){
            uploadFile = event.dataTransfer.files[0];
        }

        if( uploadFile ){
            // サムネイル表示用
            const reader = new FileReader();
            const imgEl = document.getElementById(el.dataset.target);
            const _now = document.getElementsByName(el.name.replace('_file', ''))[0];
            
            try{
                if( uploadFile.size > this.maxFilesize) {
                    throw new Error('ファイルのサイズが大きすぎます。（最大ファイルサイズ: '+ (this.maxFilesize/(1024*1024)) +' MB）');
                }

                let totalSize = 0;
                this.thumbnailEls.forEach(_el => {
                    if( _el.files.length < 1 ) return; // continueの動き

                    totalSize += _el.files[0].size;
                    if( totalSize > this.maxPostsize ){
                        throw new Error('ファイルのサイズが大きすぎます。（合計ファイルサイズ: '+ (this.maxPostsize/(1024*1024)) +' MBまで)');
                    }
                });
                
                // サムネイル表示
                reader.onload = ev => {
                    imgEl.setAttribute('src', ev.target.result);
                    imgEl.parentNode.style.display = null;
                    _now.value = 'new';
                    _now.dispatchEvent(new Event('change'));
                };
                reader.readAsDataURL(uploadFile);

                // バリデーションエラー時にデータ保持のため
                // tmpディレクトリに保存
                const url = document.getElementById('tmp_upload_url').value;
                const formData = new FormData();
                formData.append('file', uploadFile);
                formData.append('_token', el.closest('form').querySelector('[name=_token]').value);
                formData.append('tmp_upload_path', document.getElementById('tmp_upload_path').value);

                const response = await fetch(url, {
                    method: 'POST',
                    body: formData
                });
                const result = await response.json();

                if( result.status == 'error' ){
                    throw new Error(result.message);
                }
                // tmpディレクトリに保存した情報をHTMLに書き込み
                const _tmp_path = document.getElementsByName(el.name.replace('_file', '_tmp_path'))[0];
                const _tmp_name = document.getElementsByName(el.name.replace('_file', '_tmp_name'))[0];
                const _url = document.getElementsByName(el.name.replace('_file', '_url'))[0];
                document.getElementById('tmp_upload_path').value = result.path;
                if(_tmp_path) _tmp_path.value = result.path;
                if(_tmp_name) _tmp_name.value = result.name;
                if(_url)      _url.value      = result.url;

            }catch( error ){
                alert(error.message);
                el.value = '';
                el.files = null;
                // サムネイル非表示
                imgEl.setAttribute('src', null);
                imgEl.parentNode.style.display = 'none';
                _now.value = null;
                return false;
            }
        }
    }

    /**
     * 画像削除
     */
    deleteImg(el, ev) {
        ev.preventDefault();

        const imgEl = el.previousElementSibling;
        const wrapEl = el.parentNode;
        const urlEl = el.parentNode.parentNode.parentNode.querySelector('[name$="_url"]');
        const nowName = urlEl.name.replace('_url', '');
        const nowEl = el.parentNode.parentNode.parentNode.querySelector('[name='+nowName+']');
        const fileEl = el.parentNode.parentNode.parentNode.querySelector('.thumbnail');

        imgEl.src = '';
        wrapEl.style.display = 'none';
        urlEl.value = '';
        nowEl.value = '';
        fileEl.value = '';
    }

    /**
     * ファイル尾ドラッグ＆ドロップ
     */
    dragover(el, ev) {
        ev.preventDefault();
        el.style.background = '#e1e7f0';
    }

    dragleave(el, ev) {
        ev.preventDefault();
        el.style.background = '#ffffff';
    }

    uploadDocument(el, ev) {
        ev.preventDefault();

        let files = ev.dataTransfer.files;
        let inputEl = el.querySelector('[type=file]');
        inputEl.files = files;

        this.thumbnail(inputEl, ev.dataTransfer);
    }

    /**
     * 文字数カウント
     */
    countWord(el) {
        // テキストだったら親ノードをelにしないとうまくいかない
        if( el.nodeName == '#text' ){
            el = el.parentNode;
        }

        if( el.classList.contains('ck-content') ){
            const spanEl = document.querySelector(el.closest('.ck-editor').previousElementSibling.dataset.target);
            spanEl.textContent = el.textContent.length;
        }else if( el.closest('.ck-content') ){
            const spanEl = document.querySelector(el.closest('.ck-editor').previousElementSibling.dataset.target);
            spanEl.textContent = el.closest('.ck-content').textContent.length;
        }else{
            const spanEl = document.querySelector(el.dataset.target);
            spanEl.textContent = el.value.length;
        }
    }

    /**
     * 郵便番号から住所検索
     */
    searchAddressByZip(el, ev) {
        new YubinBango.Core(el.value, function(addr) {
            const formEl = el.closest('.h-adr');
            if( formEl.querySelector('select.p-region') ){
                formEl.querySelector('select.p-region').value = addr.region_id;
            }
            if( formEl.querySelector('input.p-region') ){
                formEl.querySelector('input.p-region').value = addr.region;
            }
            if( formEl.querySelector('.p-locality') ){
                formEl.querySelector('.p-locality').value = addr.locality;
            }
            if( formEl.querySelector('.p-street-address') ){
                formEl.querySelector('.p-street-address').value += addr.street;
            }
            if( formEl.querySelector('.p-extended-address') ){
                formEl.querySelector('.p-extended-address').value += addr.extended;
            }
        });
    }

    /**
     * datepickerを表示する
     */
    fireDatepicker(el){
        new Lightpick({
            field: el,
            lang: 'ja',
            format: 'YYYY/MM/DD'/*,
            minDate: moment().format('YYYY-MM-DD')*/
        });
    }

    /**
     * wysiwigエディタを表示する
     */
    async fireWysiwyg(el, type){
        if( type == 'delux' ){
            const editor = await ClassicEditor.create(el, {
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'insertImage',
                        'blockQuote',
                        '|',
                        'bulletedList',
                        'numberedList',
                        'todoList',
                        'outdent',
                        'indent'
                    ],
                    shouldNotGroupWhenFull: false
                },
                plugins: [
                    AccessibilityHelp,
                    Autoformat,
                    AutoImage,
                    Autosave,
                    BlockQuote,
                    Bold,
                    CloudServices,
                    Essentials,
                    Heading,
                    ImageBlock,
                    ImageCaption,
                    ImageInline,
                    ImageInsert,
                    ImageInsertViaUrl,
                    ImageResize,
                    ImageStyle,
                    ImageTextAlternative,
                    ImageToolbar,
                    ImageUpload,
                    Indent,
                    IndentBlock,
                    Italic,
                    Link,
                    LinkImage,
                    List,
                    ListProperties,
                    Paragraph,
                    SelectAll,
                    SimpleUploadAdapter,
                    TextTransformation,
                    TodoList,
                    Underline,
                    Undo
                ],
                heading: {
                    options: [
                        {
                            model: 'paragraph',
                            title: 'Paragraph',
                            class: 'ck-heading_paragraph'
                        },
                        {
                            model: 'heading1',
                            view: 'h1',
                            title: 'Heading 1',
                            class: 'ck-heading_heading1'
                        },
                        {
                            model: 'heading2',
                            view: 'h2',
                            title: 'Heading 2',
                            class: 'ck-heading_heading2'
                        },
                        {
                            model: 'heading3',
                            view: 'h3',
                            title: 'Heading 3',
                            class: 'ck-heading_heading3'
                        },
                        {
                            model: 'heading4',
                            view: 'h4',
                            title: 'Heading 4',
                            class: 'ck-heading_heading4'
                        },
                        {
                            model: 'heading5',
                            view: 'h5',
                            title: 'Heading 5',
                            class: 'ck-heading_heading5'
                        },
                        {
                            model: 'heading6',
                            view: 'h6',
                            title: 'Heading 6',
                            class: 'ck-heading_heading6'
                        }
                    ]
                },
                image: {
                    toolbar: [
                        'toggleImageCaption',
                        'imageTextAlternative',
                        '|',
                        'imageStyle:inline',
                        'imageStyle:wrapText',
                        'imageStyle:breakText',
                        '|',
                        'resizeImage'
                    ]
                },
                language: 'ja',
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                    decorators: {
                        toggleDownloadable: {
                            mode: 'manual',
                            label: 'Downloadable',
                            attributes: {
                                download: 'file'
                            }
                        }
                    }
                },
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                translations: [translations]
            });
            // 画像をアップロードできるよう設定
            // 1. 画像アップロードクラス作成
            class WysiwygUpload {
                constructor( loader ) {
                    this.loader = loader;
                }
                async upload() {
                    try{
                        const file = await this.loader.file;
                        
                        // tmpディレクトリに保存
                        const url = document.getElementById('tmp_upload_url').value;
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('_token', document.getElementsByName('csrf-token')[0].content);
                        formData.append('tmp_upload_path', document.getElementById('tmp_upload_path').value);

                        const response = await fetch(url, {
                            method: 'POST',
                            body: formData
                        });
                        const result = await response.json();

                        if( result.status == 'error' ){
                            throw new Error(result.message);
                        }

                        document.getElementById('tmp_upload_path').value = result.path;
                        return {default: result.url};

                    }catch( error ){
                        this.notifyTxt.textContent = error.message;
                        this.notify.firstElementChild.classList.add('error');
                        this.notify.style.display = null;
                        return false;
                    }
                }
            }
            // 2. 画像アップロード処理 
            editor.plugins.get('FileRepository').createUploadAdapter = loader => new WysiwygUpload(loader);

        }else{
            ClassicEditor.create(el, {
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'bulletedList',
                        'numberedList'
                    ],
                    shouldNotGroupWhenFull: false
                },
                plugins: [
                    Bold,
                    Essentials,
                    Heading,
                    ImageBlock,
                    Italic,
                    List,
                    ListProperties,
                    Paragraph,
                    SelectAll,
                    Underline,
                    Undo
                ],
                heading: {
                    options: [
                        {
                            model: 'paragraph',
                            title: 'Paragraph',
                            class: 'ck-heading_paragraph'
                        },
                        {
                            model: 'heading2',
                            view: 'h2',
                            title: 'Heading 1',
                            class: 'ck-heading_heading2'
                        },
                        {
                            model: 'heading3',
                            view: 'h3',
                            title: 'Heading 2',
                            class: 'ck-heading_heading3'
                        }
                    ]
                },
                language: 'ja',
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                translations: [translations]
            });
        }
    }
    
    /**
     * パスワードの表示・非表示を切り替える
     */
    togglePasswordDisplay(el) {
        if( el.previousElementSibling.type == 'password' ){
            el.previousElementSibling.type = 'text';
            el.classList.remove('eye-slash');
            el.classList.add('eye');
        }else{
            el.previousElementSibling.type = 'password';
            el.classList.remove('eye');
            el.classList.add('eye-slash');
        }
    }

    /**
     * ページ離脱前
     */
    leaveAlert(ev){
        if( this.doAction && !this.isSubmit ){
            ev.preventDefault();
            ev.returnValue = 'check'; // 空文字以外何でも良い
        }
    }

    /**
     * ページ離脱後
     */
    leavePage(ev){
        if( this.doAction && !this.isSubmit ){
            // バリデーションエラー時にデータ保持のための
            // tmpディレクトリを削除
            const tmpUploadPath = document.getElementById('tmp_upload_path').value;
            if( document.getElementById('tmp_upload_path').value != '' ){
                const url = document.getElementById('tmp_delete_url').value;
                const formData = new FormData();
                formData.append('_token', document.querySelector('form [name=_token]').value);
                formData.append('tmp_upload_path', tmpUploadPath);
                navigator.sendBeacon(url, formData);
            }
        }
    }

    /**
     * フォームフィールドにアクションを起こしたらdoActionを１にする
     */
    detectAction(){
        this.submitBtnEls.forEach(el => el.closest('form').querySelectorAll(`
            input[type=text], input[type=number], input[type=tel], input[type=email], input[type=password],
            input[type=checkbox], input[type=radio], input[type=file],
            textarea, select
        `).forEach(el2 => el2.addEventListener('change', () => this.doAction = true)));
    }
}

window.FormEdit = new FormEdit();
